import { MealDate } from '@hewey/shared'

const pad = (n: number): string => String(n).padStart(2, '0')

export const toIsoDate = (d: Date): MealDate =>
	MealDate.parse(
		`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
	)

// Monday-at-midnight of the week containing `d`, in local time. getDay() is
// 0=Sun..6=Sat, so Sunday shifts back 6 and every other day shifts to day 1.
export const mondayOf = (d: Date): Date => {
	const r = new Date(d)
	r.setHours(0, 0, 0, 0)
	const day = r.getDay()
	const offset = day === 0 ? -6 : 1 - day
	r.setDate(r.getDate() + offset)
	return r
}

export const addDays = (d: Date, n: number): Date => {
	const r = new Date(d)
	r.setDate(r.getDate() + n)
	return r
}

const WEEKDAY = new Intl.DateTimeFormat('en-GB', { weekday: 'short' })
const MONTH = new Intl.DateTimeFormat('en-GB', { month: 'short' })

export const dayLabel = (d: Date): { weekday: string; date: string } => ({
	weekday: WEEKDAY.format(d),
	date: `${d.getDate()} ${MONTH.format(d)}`,
})

// Mon–Fri are working days; Sat–Sun are the weekend.
export const isWeekend = (iso: MealDate): boolean => {
	const day = new Date(`${iso}T00:00:00Z`).getUTCDay()
	return day === 0 || day === 6
}

// Whole days from `a` to `b`. Read as UTC midnight so a clock change between
// them can't round the difference off by one.
export const daysBetween = (a: MealDate, b: MealDate): number =>
	Math.round(
		(Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) /
			86_400_000,
	)

// Shift an ISO date by whole days, in the local calendar.
export const addDaysIso = (iso: MealDate, n: number): MealDate =>
	toIsoDate(addDays(new Date(`${iso}T00:00:00`), n))

// "Mon 8 Sep" — the two lines a day row's label carries, on one line.
export const dayLabelLine = (iso: MealDate): string => {
	const { weekday, date } = dayLabel(new Date(`${iso}T00:00:00`))
	return `${weekday} ${date}`
}
